import React, { useState, useRef, useLayoutEffect } from 'react';
import { Button, Space, Tooltip } from 'antd';
import { BugOutlined, WarningOutlined } from '@ant-design/icons';

// This component simulates actual DOM manipulation errors
const TestErrorComponent = () => {
  const [simulateCriticalError, setSimulateCriticalError] = useState(false);
  const [regularErrorSimulated, setRegularErrorSimulated] = useState(false);
  const containerRef = useRef(null);

  // Simulate DOM manipulation errors (only for critical errors)
  useLayoutEffect(() => {
    if (!simulateCriticalError || !containerRef.current) return;
    
    let tempNode;
    
    try {
      // Create a node
      tempNode = document.createElement('div');
      tempNode.id = 'temp-node';
      
      // Try to remove a child that doesn't exist (will cause a DOM error)
      containerRef.current.removeChild(tempNode);
    } catch (e) {
      // Let the error propagate to the error boundary
      throw e;
    } finally {
      // Reset simulation state
      setSimulateCriticalError(false);
    }
  }, [simulateCriticalError]);

  // Handle regular error in an event handler without throwing
  const handleRegularError = () => {
    // Log a warning without throwing (this won't cause unmounting)
    console.warn('[WARNING] Test error: Regular test error');
    
    // Set state to indicate error was simulated (for visual feedback)
    setRegularErrorSimulated(true);
    
    // Reset after a short delay
    setTimeout(() => {
      setRegularErrorSimulated(false);
    }, 3000);
  };

  return (
    <div style={{ marginTop: 16, textAlign: 'center' }}>
      <div ref={containerRef} style={{ display: 'none' }}></div>
      {regularErrorSimulated && (
        <div style={{ marginBottom: 8, color: '#faad14' }}>
          Regular error successfully logged (check console)
        </div>
      )}
      <Space>
        <Tooltip title="Simulate Critical Error">
          <Button 
            type="primary"
            danger
            icon={<BugOutlined />}
            onClick={() => setSimulateCriticalError(true)}
          />
        </Tooltip>
        <Tooltip title="Simulate Regular Error">
          <Button 
            type="primary"
            icon={<WarningOutlined />}
            onClick={handleRegularError}
            style={{ backgroundColor: regularErrorSimulated ? '#faad14' : undefined }}
          />
        </Tooltip>
      </Space>
    </div>
  );
};

export default TestErrorComponent; 